import PubSub from 'pubsub-js';
import PubSubEventEnum from '../../../enums/PubSubEventEnum';

// eslint-disable-next-line import/prefer-default-export
export const publishTablePreservationReset = () => {
  PubSub.publish(PubSubEventEnum.RESET_TABLE);
  PubSub.publish(PubSubEventEnum.RESET_FILTER);
};
